import { render, staticRenderFns } from "./ProfileAttentionsByType.vue?vue&type=template&id=cacbbd0e&scoped=true&"
import script from "./ProfileAttentionsByType.vue?vue&type=script&lang=js&"
export * from "./ProfileAttentionsByType.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAttentionsByType.vue?vue&type=style&index=0&id=cacbbd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacbbd0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('cacbbd0e', component.options)
    } else {
      api.reload('cacbbd0e', component.options)
    }
    module.hot.accept("./ProfileAttentionsByType.vue?vue&type=template&id=cacbbd0e&scoped=true&", function () {
      api.rerender('cacbbd0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/attentions_by_type/ProfileAttentionsByType.vue"
export default component.exports